<template>
    <div id="app">
        <pageHeader v-if="!vuex_h5" />
        <pageHeaderMobile v-if="vuex_h5" />
        <div class="layout-box">
            <router-view></router-view>
        </div>
        <pageFooter />
        <goTop></goTop>
        <!-- <pageAside /> -->
        <!-- <pageKefu /> -->
    </div>
</template>

<script>
import pageHeader from '@/components/page/page-header.vue' //顶部搜索
import pageHeaderMobile from '@/components/page/page-header-mobile.vue' //顶部搜索
import pageFooter from '@/components/page/page-footer.vue'
import goTop from '@/components/goTop/goTop'
// import pageAside from "@/components/page/page-aside.vue";
// import pageKefu from "@/components/page/page-kefu.vue";

import { mapState } from 'vuex'
export default {
    components: {
        pageHeader,
        pageHeaderMobile,
        pageFooter,
        goTop,
        // pageAside,
        // pageKefu,
    },
    data() {
        return {}
    },
    computed: {},
    watch: {},
    beforeCreate() {},
    created() {},
    mounted() {
        this.initScale()
        this.queryConfig()
    },
    methods: {
        // scrollToTop() {
        //   let disallowScrollPages = ["product-detail"];
        //   if (disallowScrollPages.includes(this.$route.name)) {
        //   } else {
        //     document.querySelector("#app-wrap").scrollTop = 0;
        //   }
        // },
        initScale() {
            if (document && document.documentElement && document.documentElement.clientWidth) {
                let clientWidth = document.documentElement.clientWidth
                if (clientWidth <= 1366 && clientWidth >= 1024) {
                    // document.querySelector("body").style.overflowX = "auto";
                    // var $target = document.querySelector('[name="viewport"]');
                    // document
                    //   .querySelector('[name="viewport"]')
                    //   .setAttribute("content", "width=device-width,  initial-scale=0.15");
                }

                // 笔记本电脑端  150% 缩放比例的问题
                // if (window.devicePixelRatio == 1.5) {
                //     let fontSize = 10 / window.devicePixelRatio
                //     document.documentElement.style.fontSize = fontSize + 'px'
                // }
            }
        },

        queryConfig() {
            this.$api('index_config').then((res) => {
                if (res.data && res.data.comLogo) {
                    let iconUrl = res.data.comLogo
                    var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
                    link.type = 'image/x-icon'
                    link.rel = 'shortcut icon'
                    link.href = iconUrl //icon图标
                    document.getElementsByTagName('head')[0].appendChild(link)
                }
            })
        },
    },
}
</script>

<style lang="less">
.commonMyWrap {
    width: @width;
}

.poster-box .poster {
    object-fit: cover;
}

body {
    background-color: #fff;
    font-size: 14px;
    min-width: fit-content;
    width: 100%;
    text-align: left;
    overflow-x: hidden;
    height: 100vh;
    overflow-y: auto;

    &.lock {
        overflow: hidden;
    }
}

#app-wrap {
    height: 100vh !important;
    overflow-y: auto !important;

    &.lock {
        overflow-y: hidden !important;
    }
}

// 电脑端
@media screen and (min-width: 1199px) {
    body {
        height: inherit;
        overflow-y: initial;

        &.lock {
            overflow: auto;
        }
    }

    #app-wrap {
        height: inherit !important;
        overflow-y: initial !important;

        &.lock {
            overflow-y: initial !important;
        }
    }
}

#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333;
    background: #fff;

    &.lock {
        height: 100vh !important;
        overflow: hidden !important;
    }
}

.el-rate__icon {
    // color: #f7bb04 !important;
}

.el-textarea__inner:focus {
    border-color: #ff4d00 !important;
}

.el-radio__input.is-checked .el-radio__inner {
    background: #ff4d00 !important;
    border-color: #ff4d00 !important;
}

.el-radio__input.is-checked + .el-radio__label {
    color: #000 !important;
}

.el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #ff4d00 !important;
}

.el-checkbox__input.is-checked + .el-checkbox__label {
    color: #ff4d00 !important;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background: #ff4d00 !important;
    border-color: #ff4d00 !important;
}

.pagination-box {
    text-align: center;
}

.empty {
    min-height: 10vh;
    line-height: 10vh;
    text-align: center;
}

button {
    background: transparent;
}

.scale-wrap:hover .scale-target {
    transform: scale(1.1);
}

.scale-inner {
    overflow: hidden;
}

.scale-target {
    transition: 0.5s;
}

.img-cover img {
    object-fit: cover;
}

.cover img {
    object-fit: cover;
}

a {
    text-decoration: none;
    outline: none;
}

img {
    vertical-align: bottom;
}

button {
    transition: 0.2s;

    &:hover {
        opacity: 0.8;
    }
}

.hover-link {
    transition: 0.3s;

    &:hover {
        opacity: 0.7;
    }
}

.scale-box {
    overflow: hidden;

    & > .scale-img {
        width: 100%;
        height: 100%;
        transition: 0.25s linear;
        cursor: pointer;
        object-fit: cover;
    }

    &:hover {
        & > .scale-img {
            transform: scale(1.1);
        }
    }
}

.img-bg-ani {
    animation: bg_img_scale 8s infinite;
}

@keyframes bg_img_scale {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.05);
    }

    100% {
        transform: scale(1);
    }
}

//按钮 水波涟漪效果
.btn-ripple {
    vertical-align: bottom;
}

.btn-ripple:not(:disabled):hover {
    opacity: 1;
    position: relative;
    overflow: hidden;

    &::before {
        animation: ani_ripple 0.75s;
        z-index: 1;
        content: '';
        position: absolute;
        display: block;
        transition: all 0.6s;
        width: 100%;
        height: 0;
        border-radius: 50%;
        left: 50%;
        top: 50%;
        padding-top: 100%;
        transform: translateX(-50%) translateY(-50%);
    }
}

@keyframes ani_ripple {
    0% {
        background: rgba(0, 0, 0, 0.25);
        transform: translateX(-50%) translateY(-50%) scale(0);
    }

    to {
        background: transparent;
        transform: translateX(-50%) translateY(-50%) scale(1);
    }
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
    background-color: #f4f4f5 !important;
    min-width: 30px !important;
    height: 30px;
    line-height: 30px;
}

.el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #ff4d00 !important;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #ff4d00 !important;
    color: #fff !important;
}

.el-pager li.active {
}

// //PC  加载中
// .el-loading-spinner {
//   background-image: url("~@img/loading.gif");
//   background-position: center;
// }

//通用 移动端适配开始
@media screen and (max-width: 1199px) {
    #app {
        padding-top: 50px !important;

        &.technologyPdf {
            padding-top: 0 !important;
        }

        &.productSpecification {
            padding-top: 0 !important;
        }

        &.productSpecificationPdf {
            padding-top: 0 !important;
        }
    }

    .page-app {
        * {
            max-width: 100vw;
        }
    }

    .layout-box {
        min-height: 40vh;
    }

    // 输入框
    body .el-input__inner {
        font-size: 14px;
        text-align: left;
    }

    body .el-input__inner::-webkit-input-placeholder {
        font-size: 14px;
    }

    body .el-textarea__inner::-webkit-input-placeholder {
        font-size: 14px;
    }

    body .el-textarea__inner {
        font-size: 14px;
    }

    .el-upload__tip {
        font-size: 14px !important;
    }

    // 下拉选
    .el-select-dropdown__empty {
        font-size: 12px;
        height: 32px;
        line-height: 32px;
    }

    .el-select-dropdown__wrap {
        max-height: 230px !important;
    }

    .el-select-dropdown__item {
        line-height: 32px !important;
        height: 32px !important;
        padding-left: 10px !important;
        font-size: 14px !important;
    }

    .el-input__suffix {
        width: 32px !important;
        height: 32px !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
    }

    .el-select__caret {
        width: 12px;
        height: 12px;
        width: 32px !important;
        height: 32px !important;
        line-height: 0;
    }

    // 复选框样式
    .el-checkbox__inner {
        width: 14px !important;
        height: 14px !important;
    }

    .el-checkbox__inner::after {
        width: 3px !important;
        height: 8px !important;
        left: 4px !important;
    }

    .el-checkbox__label {
        font-size: 14px !important;
    }

    // 空列表
    .el-empty__image {
        width: 80px !important;
    }

    .el-empty__description {
        margin-top: 20px !important;
    }

    .el-empty__description p {
        font-size: 14px !important;
    }

    // 分页
    .el-pagination {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .el-pagination button,
    .el-pagination span:not([class*='suffix']) {
        font-size: 12px !important;
    }

    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
        width: 24px;
        height: 24px;
        line-height: 24px;
        font-size: 12px !important;
    }

    // 提示框
    .el-message {
        padding: 10px !important;
    }

    .el-icon-error:before {
        font-size: 14px !important;
    }

    .el-message__content {
        font-size: 14px !important;
    }

    .el-loading-spinner i {
        font-size: 20px !important;
    }

    .el-loading-text {
        font-size: 14px !important;
        margin-top: 10px !important;
    }

    // 大图预览  图片查看
    .el-image-viewer__actions {
        display: none;
    }

    .el-image-viewer__wrapper .el-image-viewer__close {
        top: 20px;
        right: 20px;
    }

    .el-image-viewer__wrapper .el-icon-close {
        font-size: 24px;
    }

    .el-image-viewer__next {
        width: 36px !important;
        height: 36px !important;

        .el-icon-arrow-left:before {
            font-size: 16px;
        }
    }

    .el-image-viewer__prev {
        width: 36px !important;
        height: 36px !important;

        .el-icon-arrow-right:before {
            font-size: 16px;
        }
    }

    // 弹窗样式
    .el-dialog__wrapper {
        display: flex;
        justify-content: center;
        align-items: center;

        .el-dialog {
            margin-top: 0 !important;
            margin-bottom: 0 !important;
            width: 95%!important;
        }
    }
}

@media screen and (max-width: 1199px) {
    // 商品详情弹窗
    .pop-kefu-inner {
        padding: 25px !important;

        .kefu-tip {
            margin-bottom: 20px !important;
        }
    }

    .detail-qrcode {
        .flex-center();
        text-align: center;

        img {
            border: 1px solid #ddd;
            width: 150px !important;
            height: 150px !important;
        }
    }
}

@media screen and (max-width: 1199px) and (min-width: 768px) {
    #mobile_icon_div > div {
        width: 70px !important;
        height: 70px !important;
        display: flex;
        justify-content: center;
        align-items: center;

        & > div {
            margin: 0 !important;
            width: 35px !important;
            height: 35px !important;
        }
    }
}

//通用 移动端适配开始
@media screen and (max-width: 1024px) {
    body {
        overflow-x: hidden;

        &.lock {
            overflow: hidden;
        }
    }
    * {
        max-width: 100vw;
        // overflow-x: hidden;
        font-size: 19px;
    }

    .content6 header,
    .content5 .content5-box header {
        font-size: 19px !important;
        padding-bottom: 0 !important;
    }
    .product-list .product-item .img-box {
        padding-bottom: 0px !important;
    }
    .product-list .product-item .info-box .title {
        min-height: auto !important;
        margin: 0 !important;
    }
    .product-list .product-item {
        min-height: auto !important;
        margin-bottom: 20px !important;
        margin-top: 0 !important;
    }
    .product-list .product-item .collect-icon {
        z-index: 9;
        top: 10px !important;
        right: 10px !important;
        left: auto !important;
    }
    .product-list .product-item .collect-icon img {
        width: 40px !important;
        height: 40px !important;
    }
    .product-item-info.flex {
        display: block !important;
    }
    .product-list .product-item .info-box {
        width: 100% !important;
        padding: 10px 0 !important;
    }
    .price-box.flex {
        display: block !important;
        margin-top: 0 !important;
    }
    .price-box.flex .sale {
        margin-top: 0px !important;
        text-align: left;
    }
    .product-list .product-item .info-box > div:nth-child(2) {
        padding-top: 4px !important;
        padding-bottom: 12px !important;
    }
    .content5 {
        padding: 10px 0 !important;
    }

    .content5-list.flex .content5-item {
        width: calc(100% - 40px) !important;
        margin: 20px !important;
    }
    .content5 .content5-box .content5-list .content5-item {
        padding: 20px !important;
        height: auto !important;
        border-radius: 0 0 30px 0 !important;
    }

    .content6 header {
        padding-top: 30px !important;
        margin-bottom: 20px !important;
    }
    .content6 .content6-box {
        margin-top: 0 !important;
        display: block !important;
        padding: 0 20px !important;
    }
    .content6 .content6-box .content6-section {
        width: 100% !important;
        margin: 0 !important;
    }
    .content6 .content6-box .content6-section h3 {
        font-size: 17px !important;
        margin: 0 !important;
        line-height: 1.5 !important;
    }
    .content6 .content6-box .content6-section .textoverflow6 {
        font-size: 16px !important;
        line-height: 1.5 !important;
    }
    .content6 .content6-box .content6-section .more-box {
        margin-top: 30px !important;
        margin-bottom: 30px !important;
        display: flex;
        align-items: center;
    }
    .content6 .content6-box .content6-section .more-box a {
        margin-left: auto !important;
        margin-right: auto !important;
        font-size: 18px;
        height: 3rem !important;
    }
    .content6 .content6-box > img {
        width: 100% !important;
        height: auto !important;
        border-radius: 20px !important;
    }

    .page-top {
        height: auto !important;
        line-height: 18px !important;
        padding: 6px 0 !important;
    }
    // .page-top .page-bread {
    //   background: #ffffff !important;
    // }
    .el-breadcrumb__item {
        font-size: 15px !important;
        line-height: normal !important;
        span {
            font-size: 15px !important;
            line-height: normal !important;
        }
        i {
            font-size: 15px !important;
        }
    }
    .el-icon-s-home {
        margin-right: 5px !important;
    }

    .el-icon-s-home:before {
        font-size: 15px !important;
    }

    .zhutu-wrap {
        height: auto !important;
    }

    .detail-content-box .rich-html p {
        font-size: 15px !important;
        line-height: 1.4 !important;
    }
    .detail-content-box img {
        height: auto !important;
    }
    .block-xunjia {
        background: #fff !important;
        width: 100%;
    }

    .block-xunjia .xunjia-box .input-item {
        padding-left: 0 !important;
    }
    .block-xunjia {
        width: 100% !important;
    }
    .block-xunjia .xunjia-box .input-item {
        margin-right: 0 !important;
        display: flex;
        align-items: center;
    }
    .block-xunjia .xunjia-box .input-item .label {
        position: relative !important;
        top: 0 !important;
        width: 110px !important;
        padding-right: 10px;
        margin-bottom: 0 !important;
    }

    .block-xunjia .xunjia-box .input-item.full {
        align-items: start;
    }
    .block-xunjia .xunjia-box .input-item.full .label {
        padding-top: 8px;
        width: 110px !important;
        padding-right: 10px;
    }
    .block-xunjia .xunjia-box .input-item.full .input-box {
        width: 30%;
    }
    .block-xunjia .submit-box {
        display: flex;
    }
    .block-xunjia .submit-box button {
        padding: 0 !important;
    }
    .block-xunjia .submit-box button span {
        font-size: 16px !important;
    }
    .page .inner .page-ctx .pagination-box {
        margin-top: 10px !important;
    }

    .content6 .content6-box .content6-section section {
        font-size: 17px !important;
        line-height: 1.5 !important;
        margin-bottom: 20px !important;
    }

    .section-order .input-box .label {
        width: 90px !important;
    }

    .section-order .order-list-wrap .info-title .order-code span {
        font-size: 12px;
    }
    .section-order .order-list-wrap .info-title .order-state {
        top: 6px !important;
        padding: 0 !important;
    }

    .section-order .order-list-wrap .info-good .list-good .item-good .box-price,
    .section-order .order-list-wrap .info-good .list-good .item-good .box-num,
    .section-order .order-list-wrap .info-good .list-good .item-good .goods-sku,
    .section-order .order-list-wrap .info-good .list-good .item-good .goods-title {
        text-align: left !important;
        font-size: 16px !important;
    }
    .section-order .order-list-wrap .info-good .list-good .item-good .box-num {
        width: 100%;
    }
    .section-order .order-list-wrap .info-heji .heji .heji-num b:last-child {
        display: block;
    }
    .section-order .order-list-wrap .info-heji .heji .heji-num b,
    .section-order .order-list-wrap .info-heji .heji .heji-num {
        font-size: 15px;
        line-height: 1.5;
    }
    .order-list-wrap .info-heji .btn-actions button {
        height: 34px !important;
        font-size: 14px !important;
        margin-bottom: 6px !important;
        margin-top: 6px !important;
    }
    .btn-validate-box span {
        font-size: 14px !important;
    }
    .btn-validate-box {
        font-size: 14px !important;
    }
    #app {
        padding-top: 50px !important;

        &.technologyPdf {
            padding-top: 0 !important;
        }

        &.productSpecification {
            padding-top: 0 !important;
        }

        &.productSpecificationPdf {
            padding-top: 0 !important;
        }
    }

    .page-app {
        * {
            max-width: 100vw;
        }
    }

    .layout-box {
        min-height: 40vh;
    }

    // 输入框
    body .el-cascader .el-input {
        font-size: 16px;
        line-height: 39px;
    }
    body .el-input__inner {
        font-size: 14px;
        text-align: left;
    }
    body .el-cascader {
        line-height: 39px;
    }
    body .el-input__inner::-webkit-input-placeholder {
        font-size: 14px;
    }
    body .el-cascader .el-input .el-icon-arrow-down {
        line-height: 39px;
    }
    body .el-textarea__inner::-webkit-input-placeholder {
        font-size: 14px;
    }

    body .el-textarea__inner {
        font-size: 14px;
    }

    .el-upload__tip {
        font-size: 14px !important;
    }
    .el-form-item__error {
        font-size: 16px !important;
    }
    .el-form-item__label {
        font-size: 16px !important;
    }
    .el-form-item__label {
        width: 30%;
        white-space: nowrap;
    }
    .el-form-item {
        display: flex;
        align-content: center;
    }
    .el-form-item__content {
        margin-left: 10px;
        width: 100%;
    }
    .el-tabs__item {
        font-size: 16px !important;
    }
    // 下拉选
    .el-select-dropdown__empty {
        font-size: 12px;
        height: 32px;
        line-height: 32px;
    }

    .el-select-dropdown__wrap {
        max-height: 230px !important;
    }

    .el-select-dropdown__item {
        line-height: 32px !important;
        height: 32px !important;
        padding-left: 10px !important;
        font-size: 14px !important;
    }

    .el-input__suffix {
        width: 32px !important;
        height: 100% !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
    }

    .el-select__caret {
        width: 12px;
        height: 12px;
        width: 32px !important;
        height: 32px !important;
        line-height: 0;
    }

    // 复选框样式
    .el-checkbox__inner {
        width: 14px !important;
        height: 14px !important;
    }

    .el-checkbox__inner::after {
        width: 3px !important;
        height: 8px !important;
        left: 4px !important;
    }

    .el-checkbox__label {
        font-size: 14px !important;
    }

    // 空列表
    .el-empty__image {
        width: 80px !important;
    }

    .el-empty__description {
        margin-top: 20px !important;
    }

    .el-empty__description p {
        font-size: 14px !important;
    }

    // 分页
    .el-pagination {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .el-pagination button,
    .el-pagination span:not([class*='suffix']) {
        font-size: 12px !important;
    }

    .el-pagination.is-background .el-pager {
        display: flex;
        flex-wrap: wrap;
        row-gap: 10px;
    }

    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
        width: 24px;
        height: 24px;
        line-height: 1.8;
        font-size: 12px !important;
        min-width: 1rem !important;
    }
    .el-pager .more::before {
        line-height: 24px !important;
    }

    // 提示框
    .el-message {
        padding: 10px !important;
    }

    .el-icon-error:before {
        font-size: 14px !important;
    }

    .el-message__content {
        font-size: 14px !important;
    }

    .el-loading-spinner i {
        font-size: 20px !important;
    }

    .el-loading-text {
        font-size: 14px !important;
        margin-top: 10px !important;
    }

    .el-message {
        min-width: 96% !important;
        margin: 0 auto !important;
    }

    // 大图预览  图片查看
    .el-image-viewer__actions {
        display: none !important;
    }

    .el-image-viewer__wrapper .el-image-viewer__close {
        top: 20px;
        right: 20px;
        width: 3rem;
        height: 3rem;
    }

    .el-image-viewer__wrapper .el-icon-close {
        font-size: 24px;
    }

    .el-image-viewer__next {
        display: none !important;
        width: 36px !important;
        height: 36px !important;

        .el-icon-arrow-left:before {
            font-size: 16px;
        }
    }

    .el-image-viewer__prev {
        display: none !important;
        width: 36px !important;
        height: 36px !important;

        .el-icon-arrow-right:before {
            font-size: 16px;
        }
    }

    // 弹窗样式
    .el-dialog__wrapper {
        display: flex;
        justify-content: center;
        align-items: center;

        .el-dialog {
            margin-top: 0 !important;
            margin-bottom: 0 !important;
        }
    }
    .el-popper{
        max-width: 95%;
        left: 50%!important;
        transform: translateX(-50%);
        margin: 0!important;
        min-width: 0 !important;
        padding: 0 !important;
        .previewImgBox{
            max-width: 100%;
            img{
                max-width: 100%;
            }
        }
    }
    .el-popper[x-placement^=right] .popper__arrow{
        display: none;
    }
    .el-scrollbar {
        > .el-scrollbar__bar {
            opacity: 1 !important;
        }
    }
}
</style>
